import React from 'react';
import {Container, Typography, Box, keyframes} from '@mui/material';

function SectionTitle({title}) {

    const breathingTitle = keyframes`
      0% { scale: 1; }
      50% { scale: 0.7; }
      100% { scale: 1; }
    `;

    const sxBgTitle = {
        position: 'sticky',
        height: 0,
        top: 100,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: -50,
        color: '#8D8A80',
        fontSize: 160,
        margin: 'auto',
        textAlign: 'center',
        fontFamily: 'Copperplate',
        textTransform: 'uppercase',
        opacity: 0.04,
        animation: `${breathingTitle} 10s infinite cubic-bezier(0.4, 0, 1, 1)`,
    };

    return (
        <>
            <Typography variant="h1" fontWeight={'bold'} sx={sxBgTitle} >
                {title}
            </Typography>
            <Container sx={{ padding: '64px 0'}}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h1" fontWeight={'bold'} >
                        {title}
                    </Typography>
                </Box>
            </Container>
        </>
    );
}

export default SectionTitle;